import { get } from '@alltrails/core/utils/get';
import type { Map } from '@alltrails/types/Map';

export default async function getMap(mapId: number) {
  return get<{ maps?: Map[] }>(`/api/alltrails/maps/${mapId}`, { params: { detail: 'deep' } }).then(({ maps }) => {
    if (maps?.length) {
      return maps[0];
    }
    return undefined;
  });
}
